import type { TrapGroup } from '@features/regional-overview/digital-traps/domain/trap.models';

export const createCustomOption = (value: string): TrapGroup => ({
  id: '',
  title: value,
  customGroup: false,
  trapList: [],
  trapsInGroup: []
});
